import { ERROR_SERVER, GET_ACCESS_OPENINGS, IS_FETCHING, SET_ACCESS_OPENING } from "./types";

const AccessOpeningReducer = (state, action) => {
    const { type, payload } = action;
    switch (type) {
        case GET_ACCESS_OPENINGS:
            return {
                ...state,
                accessOpenigs: payload,
                isFetching: false,
                error: false,
                wasFetched: true,
                message: ''
            }
        case IS_FETCHING:
            return {
                ...state,
                isFetching: true,
                error: false,
                message: '',
                wasFetched: false
            }
        case ERROR_SERVER:
            return {
                ...state,
                isFetching: false,
                error: true,
                wasFetched: false,
                message: payload
            }
        case SET_ACCESS_OPENING:
            return {
                ...state,
                accessOpenigs: [],
                isFetching: true,
                error: false,
                message: ''
            }

        default:
            return state
    }
}

export default AccessOpeningReducer